export function useChat(...args) {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: useChat is not implemented yet.', args);
  return { response: null, isLoading: false, error: null, sendMessage: () => {} };
}
